module.exports = __webpack_public_path__ + "static/img/15.1aa25c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/15.png
// module id = TSNY
// module chunks = 0